import React from 'react';
import { useTranslation } from 'react-i18next';
import * as S from '../../styled';

const Footer = () => {
  const { t } = useTranslation();

  return (
    <S.Footer>
      <S.FooterLeft>
        <S.FooterHint>
          <S.Keycap>⌘ + K</S.Keycap>
          <span>{t('search:common.or', 'or')}</span>
          <S.Keycap>Ctrl + K</S.Keycap>
          <span>{t('search:common.footer.globalSearch')}</span>
        </S.FooterHint>

        <S.FooterHint>
          <S.Keycap>↑↓</S.Keycap>
          <span>{t('search:common.footer.navigateResults')}</span>
        </S.FooterHint>

        <S.FooterHint>
          <S.Keycap>← →</S.Keycap>
          <span>{t('search:common.footer.navigateTabs')}</span>
        </S.FooterHint>

        <S.FooterHint>
          <S.Keycap>⏎</S.Keycap>
          <span>{t('search:common.footer.open')}</span>
        </S.FooterHint>
      </S.FooterLeft>

      <S.FooterRight>
        <S.FooterHint>
          <span>{t('search:common.footer.close')}</span>
          <S.Keycap>Esc</S.Keycap>
        </S.FooterHint>
      </S.FooterRight>
    </S.Footer>
  );
};

export default Footer;
